import videojs from "video.js"

class Hls {
  constructor() {
    this.init = false
  }
  _init = async () => {
    if (this.init) return true

    if (document.getElementById("videoplane")) document.getElementById("videoplane").remove()
    _$.loader.createPlayer("video", {
      id: "videoplane",
      controls: false,
      poster: null,
      class: "VideoJS"
    })

    videojs.Vhs.GOAL_BUFFER_LENGTH = 100
    videojs.Vhs.MAX_GOAL_BUFFER_LENGTH = 150
    this.player = videojs("videoplane", {
      autoplay: true,
      controls: false,
      preload: "auto",
      children: []
    })
    //this.player.muted(true)

    this.player.on("pause", _$.handler.emit)
    this.player.on("playing", _$.handler.emit)
    this.player.on("ended", _$.handler.emit)
    this.player.on("error", _$.handler.emit)

    this.init = true

    return true
  }
  start = async () => {
    playmore.media.playerBehind()
    return true
  }
  destroy = async () => {
    await this.stop()
    document.getElementById("videoplane").style.display = "none"
    return true
  }

  play = async () => {
    const promise = await _$.progress.create(_$.progress.type.PLAY)
    if (promise.isResolved) return false

    await this.stop()
    /* Library Code */
    this.player.src({
      src: __.media.getSource(),
      type: __.media.getSource().includes(".m3u8") ? "application/x-mpegURL" : "video/mp4",
      withCredentials: false
    })
    this.player.loop(__.media.getLoop() ? true : false)
    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      if (document.getElementById("videoplane")) document.getElementById("videoplane").style.display = null
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  stop = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    if (__.media.status === "playing" || this.player.src()) this.player.reset("src")
    if (document.getElementById("videoplane")) document.getElementById("videoplane").style.display = "none"
    _$.handler.emit("stopped")
    /* Library Code */

    promise.resolve()

    return promise.done
  }
  pause = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    this.player.pause()
    /* Library Code */

    _$.vue.$once(["mediaPaused", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  continue = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    this.player.play()
    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }

  /* Control Helpers */
  isSeekable = async () => {
    /* Library Code */
    const res = await this.getDuration()
    /* Library Code */

    return res ? true : false
  }
  getDuration = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    const duration = Math.floor(this.player.duration())

    if (duration) promise.resolve(duration)
    else promise.reject()
    /* Library Code */

    return promise.done
  }
  getPosition = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    const position = Math.floor(this.player.currentTime())

    if (position) promise.resolve(position)
    else promise.reject()
    /* Library Code */

    return promise.done
  }
  setPosition = async second => {
    const promise = await _$.progress.create()

    /* Library Code */
    if (!second || second > this.player.duration) promise.reject()
    else {
      this.player.currentTime(second)
      promise.resolve()
    }
    /* Library Code */

    return promise.done
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    const promise = await _$.progress.create()

    promise.resolve([])

    return promise.done
  }
  setSubtitle = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    promise.resolve()
    /* Library Code */

    return promise.done
  }
  closeSubtitle = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    promise.resolve()
    /* Library Code */

    return promise.done
  }

  getLanguages = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    const languages = [
      { key: "0", value: "TR" },
      { key: "1", value: "DE" },
      { key: "2", value: "???" }
    ]
    promise.resolve(languages)
    /* Library Code */

    return promise.done
  }
  setLanguage = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    promise.resolve()
    /* Library Code */

    return promise.done
  }
}

export default Hls
